import React, { Fragment } from 'react';
import If from '../../../Shared/If/If';
import {
  getExistingRMDTotalRMD,
  getIsRMDEligible,
  getShowDashboard,
} from '../../../../redux/modules/RMD/RMDSetting.selectors';
import './QCDFundEditor.scss';
import { isRAS } from '../../../../utils/advice/advice-utility';
import { useSelector } from 'react-redux';
import DistributionAmount from '../../../Sell/SellFundEditor/DistributionAmount';
import RasMaxAmount from '../../../Sell/RAS/RasMaxAmount';
import RMDAmount from '../../../Sell/RMD/RMDAmount';

const QCDFundEditor = ({
  customerWebViewEnabled,
  isSalesforceRep,
  actions,
  deliveryMethod,
  fund,
  hasNotInheritedSEPOrSimpleIRA,
  marketVolatility,
  RMData,
  transactionLimit,
  userAddress,
}) => {
  const { isFundRMDEligible } = fund;
  const isRMDEligible = useSelector(getIsRMDEligible);
  const totalRMDAMount = useSelector(getExistingRMDTotalRMD);
  const showRmdDashboardLink = useSelector(getShowDashboard);
  const distributionAmountClassName = isRAS(fund.productType)
    ? 'sell-fund-editor-rmd-eligible-container'
    : 'sell-fund-editor-container';
  return (
    <Fragment>
      <If test={!isFundRMDEligible || !hasNotInheritedSEPOrSimpleIRA}>
        <div className={distributionAmountClassName}>
          <If test={isRAS(fund.productType)}>
            <RasMaxAmount fund={fund} />
          </If>

          <DistributionAmount
            showHeader={isRAS(fund.productType)}
            {...{
              customerWebViewEnabled,
              isSalesforceRep,
              RMData,
              actions,
              deliveryMethod,
              fund,
              marketVolatility,
              transactionLimit,
              userAddress,
            }}
          />
        </div>
      </If>
      <If
        test={
          isRMDEligible && isFundRMDEligible && hasNotInheritedSEPOrSimpleIRA
        }
      >
        <span>
          <div className="sell-fund-editor-rmd-eligible-container">
            <div className="rmd-ras-withdraw-sections">
              <If test={isRAS(fund.productType)}>
                <RasMaxAmount fund={fund} />
              </If>
              {totalRMDAMount !== 0 && showRmdDashboardLink && (
                <RMDAmount
                  actions={actions}
                  fund={fund}
                  isSalesforceRep={isSalesforceRep}
                  customerWebViewEnabled={customerWebViewEnabled}
                />
              )}
            </div>

            <DistributionAmount
              showHeader
              {...{
                customerWebViewEnabled,
                isSalesforceRep,
                RMData,
                actions,
                deliveryMethod,
                fund,
                marketVolatility,
                transactionLimit,
                userAddress,
              }}
            />
          </div>
        </span>
      </If>
    </Fragment>
  );
};

export default QCDFundEditor;
